"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var OptimizationConfigurations_service_1 = __importDefault(require("./Service/OptimizationConfigurations.service"));
var OptimizationConfiguration = /** @class */ (function () {
    function OptimizationConfiguration(session) {
        this.optimizationConfigurationService = new OptimizationConfigurations_service_1.default(session);
    }
    OptimizationConfiguration.prototype.create = function (configuration) {
        return this.optimizationConfigurationService.create(configuration);
    };
    OptimizationConfiguration.prototype.list = function () {
        return this.optimizationConfigurationService.list();
    };
    OptimizationConfiguration.prototype.getById = function (id) {
        return this.optimizationConfigurationService.getById(id);
    };
    OptimizationConfiguration.prototype.update = function (id, configuration) {
        return this.optimizationConfigurationService.update(id, configuration);
    };
    OptimizationConfiguration.prototype.delete = function (id) {
        return this.optimizationConfigurationService.delete(id);
    };
    OptimizationConfiguration.prototype.getConfigurationAttributes = function () {
        return this.optimizationConfigurationService.getConfigurationAttributes();
    };
    OptimizationConfiguration.prototype.batchDelete = function (configurationIds) {
        return this.optimizationConfigurationService.batchDelete(configurationIds);
    };
    OptimizationConfiguration.prototype.getMerchantTeamSettings = function () {
        return this.optimizationConfigurationService.getMerchantTeamSettings();
    };
    return OptimizationConfiguration;
}());
exports.default = OptimizationConfiguration;
//# sourceMappingURL=OptimizationConfiguration.js.map